import { render } from "./PageArtober2023_P2.vue?vue&type=template&id=833bd9fe&scoped=true"
import script from "./PageArtober2023_P2.vue?vue&type=script&lang=js"
export * from "./PageArtober2023_P2.vue?vue&type=script&lang=js"

import "./PageArtober2023_P2.vue?vue&type=style&index=0&id=833bd9fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833bd9fe"]])

export default __exports__